import styled from "styled-components";

const StyledSignup = styled.div`
    display: flex;
    justify-content: center;

.checkbox-div{
    width: 15rem;
    display: flex;
    ${'' /* flex-direction: row; */}
    justify-content: flex-end;
}

} 
`

export default StyledSignup;